// Core
import { useState, useEffect, useCallback } from 'react';
import { Box, Flex, Button, Image, Text, useDisclosure } from '@chakra-ui/react';
import { useSpring, animated } from '@react-spring/web';
import { useDrag } from '@use-gesture/react';
import { RiMessage3Fill, RiProfileFill } from 'react-icons/ri';
import { FaHeart, FaUser, FaCheckCircle } from 'react-icons/fa';
import { IoLocationSharp, IoCloseOutline } from 'react-icons/io5';
import { IoIosClose } from 'react-icons/io';
import { MdCancel } from 'react-icons/md';
import { useQuery } from 'react-query';
import { useHistory, useLocation } from 'react-router-dom';
import { FaFilter } from 'react-icons/fa6';

// Assets
import { apiService } from 'services/ApiService';
import { textLang } from 'services/Lang';

// Components
import BalanceModal from './modals/Balance';
import FiltersModal from './modals/Filters';

const MatchGroup = ({
	active,
	setActive,
	setShowInfo,
	setShowInfoType,
	setItem,
	object
}) => {
  const [isAnimateDislike, setIsAnimateDislike] = useState(false);
  const handleDislike = (index) => {
    if(isAnimateDislike){ return; }
    setIsAnimateDislike(true);
    setTimeout(function() {
      setActive(index === 5 ? 0 : index );
      setIsAnimateDislike(false);
    }, 400);
  };

  const [isAnimateLike, setIsAnimateLike] = useState(false);
  const handleLike = (index) => {
    if(isAnimateLike){ return; }
    setIsAnimateLike(true);
    setTimeout(function() {
      setActive(index === 5 ? 0 : index );
      setIsAnimateLike(false);
    }, 400);
  };

  const [listInterests, setInterests] = useState([]);
	const toggleInterest = (interest) => {
		console.log(listInterests);
    if(toggleInterest.length > 0){
      setInterests((prev) => {
        const updatedInterests = prev.includes(interest)
          ? prev.filter((i) => i !== interest)
          : [...prev, interest];

        return updatedInterests;
      });
    } else {
      setInterests([interest]);
    }
  };

  const [isAnimateNext, setIsAnimateNext] = useState(false);
  const [groups, setGroups] = useState(true);
  const colorMatch = 'white';
  const limit = 20;
  const [offset, setOffset] = useState(0);

  const [isFetchingErrors, setIsFetchingErrors] = useState();
  const [globalSearch, setGlobalSearch] = useState(true);
  const { refetch, isFetching } = useQuery({
    queryKey: ['data-me-group', offset, globalSearch, listInterests],
    queryFn: async () => {
      const params = {
        offset,
        limit,
        ...(globalSearch && { global: globalSearch }),
        ...(listInterests.length > 0 && { interests: listInterests }),
      };

      const response = await apiService.getGroups(params);
      if (response.statusCode !== 200) {
        setIsFetchingErrors(response.message);
        setGroups([]);
        return true;
      }

      setIsFetchingErrors(undefined);
      setGroups(response.data);
      return true;
    },
    enabled: !!object, 
    refetchOnWindowFocus: false,
    retry: false,
  });

  useEffect(() => {
    if (active > 19 && active !== 0) {
      setOffset(offset + limit);
      setActive(0);
    }
  }, [active]);

  const setDisLike = useCallback(async (objectId) => {
    try {
      await apiService.dislikeGroup({id: objectId});
    } catch (e){}
    return true;
  });

  const setLike = useCallback(async (objectId) => {
    try {
      const response = await apiService.likeGroup({id: objectId});
      if(response.statusCode === 200){
        handleLike(active + 1);
      } else {
        onOpenBalance();
      }
    } catch (e){
      onOpenBalance();
    }

    return true;
  });

  const history = useHistory();
  const { isOpen: isOpenBalance, onClose: onCloseBalance, onOpen: onOpenBalance } = useDisclosure();
  const handleBalance = async () => {
      onCloseBalance();
      history.push('/profile/balance');  
  };

  const { isOpen: isOpenFilters, onClose: onCloseFilters, onOpen: onOpenFilters } = useDisclosure();
  const handleFilters = async () => {
     
  };

  return (
    <Box position="relative" overflow="visible">

    <Box 
      zIndex="999"
      position="absolute"
      transform="translate(-50%, 0px)"
      left="50%"
      mt="-60px"
      w="180px"> 
        <Button 
          variant={'solid-sm'}
          onClick={onOpenFilters}
          leftIcon={
            <FaFilter color='rgb(255, 65, 51)' />
          }>{textLang('filters')}</Button>
    </Box>

    <Box mt="30px" />

    {/*<Box 
      zIndex="999"
      position="absolute"
      transform="translate(-50%, 0px)"
      left="50%"
      mt="-30px"
      w="180px"> 
        <Button 
          variant={ globalSearch ? 'button-sm' : 'solid-sm'}
          onClick={() => setGlobalSearch(!globalSearch)}
          rightIcon={
            <FaCheckCircle 
              color={ globalSearch ? '#0fe30b' : 'rgb(255, 65, 51)'}
            />
          }>{textLang('global_search')}</Button>
    </Box>*/}
    
    { isFetching && 
      <Box position="relative" p="0 10px" overflow="visible">
        <Box 
        	overflow="visible"
        	position="relative" 
        	w="100%" 
        	transform={'translateX(0px)'}
	        opacity={'1'}
	        transition="opacity 0.5s ease-out, transform 0.5s ease-out"
	        willChange="opacity, transform" 
        	sx={{aspectRatio: '1'}}>
					<Box
						overflow="visible"
						position="absolute"
						left="0"
						w="100%"
						h="100%"
						p="24px" 
						transform = { 'scale(0.99) rotate(-5deg)'}
						zIndex="4"
						bottom="0px" 
						borderRadius="30px"
						>
		        <Box
							top="0" 
							left="0"
							position="absolute" 
							w="100%" 
							borderRadius="30px" sx={{aspectRatio: '1'}}
							transform = { 'scale(0.99) rotate(0.5deg)'}
			        transition="transform 0.3s ease-out"
			        willChange="transform"
			        bg="rgb(255 121 111)"
			        zIndex="2"
							/>
						<Box
							top="0" 
							left="0"
							position="absolute" 
							w="100%" 
							borderRadius="30px" sx={{aspectRatio: '1'}}
							transform = { 'scale(0.99) rotate(4deg)'}
			        transition="transform 0.3s ease-out"
			        willChange="transform"
			        bg="#ffffffad"
			        zIndex="1"
			        boxShadow="12px 11px 19px #f2e3dfad"
							/>
		        <Box 
		          w="100%" 
		          top="40%" 
		          textAlign="center"
		          overflow="hidden" 
		          position="relative"
		          zIndex="3"
		          transform = { 'scale(0.76) rotate(0.5deg)'}
		        >
		          <Text px="10%" variant="title-lg" fontSize="24px">
		            { textLang('loading')}
		          </Text>
		        </Box>
			    </Box>
			  </Box>
      </Box>
    }

    {(
      (!isFetching && Array.isArray(groups) && groups.length === 0) ||
      (!isFetching && groups[active]?.id === undefined)
    ) && (
      <Box position="relative" p="0 10px" overflow="visible">
        <Box 
        	overflow="visible"
        	position="relative" 
        	w="100%" 
        	transform={'translateX(0px)'}
	        opacity={'1'}
	        transition="opacity 0.5s ease-out, transform 0.5s ease-out"
	        willChange="opacity, transform" 
        	sx={{aspectRatio: '1'}}>
					<Box
						overflow="visible"
						position="absolute"
						left="0"
						w="100%"
						h="100%"
						p="24px" 
						transform = { 'scale(0.99) rotate(-5deg)'}
						zIndex="4"
						bottom="0px" 
						borderRadius="30px"
						>
		        <Box
							top="0" 
							left="0"
							position="absolute" 
							w="100%" 
							borderRadius="30px" sx={{aspectRatio: '1'}}
							transform = { 'scale(0.99) rotate(0.5deg)'}
			        transition="transform 0.3s ease-out"
			        willChange="transform"
			        bg="rgb(255 121 111)"
			        zIndex="2"
							/>
						<Box
							top="0" 
							left="0"
							position="absolute" 
							w="100%" 
							borderRadius="30px" sx={{aspectRatio: '1'}}
							transform = { 'scale(0.99) rotate(4deg)'}
			        transition="transform 0.3s ease-out"
			        willChange="transform"
			        bg="#ffffffad"
			        zIndex="1"
			        boxShadow="12px 11px 19px #f2e3dfad"
							/>
		        <Box 
		          w="100%" 
		          top="40%" 
		          textAlign="center"
		          overflow="hidden" 
		          position="relative"
		          zIndex="3"
		          transform = { 'scale(0.76) rotate(0.5deg)'}
		        >
		          <Text px="10%" variant="title-lg" fontSize="24px">
		            { isFetchingErrors ? textLang(isFetchingErrors) : textLang('no_groups')}
		          </Text>
		        </Box>
			    </Box>
			  </Box>
      </Box>
    )}

    { !isFetching && Array.isArray(groups) && groups?.length > 0 && groups[active]?.id &&
    <Box position="relative" p="0 10px" overflow="visible">
        <Box 
        	position="relative" 
        	w="100%" 
        	overflow="visible"
        	transform={isAnimateDislike ? 'translateX(-100px)' : isAnimateLike ? 'translateX(100px)' :  'translateX(0px)'}
	        opacity={isAnimateDislike ? '0' : isAnimateLike ? '0' : '1'}
	        transition="opacity 0.5s ease-out, transform 0.5s ease-out"
	        willChange="opacity, transform" 
        	sx={{aspectRatio: '1'}}>
			<Image 
				src={groups[active]?.image} 
				w="100%"
				borderRadius="30px" 
				h="100%"
				transform = { isAnimateDislike ? 'scale(0.76) rotate(-10deg)' : isAnimateLike ? 'scale(0.76) rotate(10deg)' : 'scale(0.99) rotate(-5deg)'}
		        transition="transform 0.5s ease-out"
		        willChange="transform"
				objectFit="cover"
				zIndex="3"
				position="relative"
				/>

			<Box
				position="absolute"
				left="0"
				w="100%"
				h="100%"
				p="24px" 
				transform = { isAnimateDislike ? 'scale(0.76) rotate(-10deg)' : isAnimateLike ? 'scale(0.76) rotate(10deg)' : 'scale(0.99) rotate(-5deg)'}
		        transition="transform 0.5s ease-out"
		        willChange="transform"
				zIndex="4"
				bottom="0px" 
				borderRadius="30px"
				bg="linear-gradient(0deg, black, transparent)">
	            
	            <Flex
	              bg="#00000033"
	              width="max-content"
	              padding="4px 8px"
	              borderRadius="4px"
	              backdropFilter="blur(4px)"
	              gap="4px" alignItems="center">
	              <IoLocationSharp color="#E1E1E1" fontSize="16px" />
	              <Text variant="text-xs" color={colorMatch} textShadow="0.5px 0.5px black">{groups[active]?.country}, {groups[active]?.city}</Text>
	            </Flex>

				<Flex justifyContent='start' gap="8px" alignItems='center' w="100%">
	              <Text variant='title-xl' noOfLines={2} color={colorMatch} textShadow="1px 1px black">{groups[active]?.name}</Text>
	            </Flex>

	            <Box onClick={() => {setShowInfo(true); setShowInfoType('match'); setItem(groups[active]);}} position="absolute" top="24px" right="24px">
	                <RiProfileFill color={colorMatch} fontSize="36px" />
	            </Box>

	            <Text 
	              variant="text-md"
	              color={colorMatch} 
	              mt="16px"
	              sx={{
	                display: '-webkit-box',
	                WebkitBoxOrient: 'vertical',
	                WebkitLineClamp: 2,
	                overflow: 'hidden',
	              }}
	            >
	              {groups[active]?.description}
	            </Text>
	            
	            <Flex gap='8px' mt='12px' flexWrap='wrap'>
			          {groups[active]?.interests?.map((item, index) => (
			            <Box className='tag-interests' key={index}>{textLang(item)}</Box>
			          ))}
			        </Flex>
	         </Box>

			<Box
				top="0" 
				position="absolute" 
				w="100%" 
				borderRadius="30px" sx={{aspectRatio: '1'}}
				transform = { isAnimateDislike ? 'scale(0.7) rotate(-10deg)' : isAnimateLike ? 'scale(0.7) rotate(10deg)' : 'scale(0.99) rotate(-2.5deg)'}
		        transition="transform 0.3s ease-out"
		        willChange="transform"
		        bg="rgb(255 121 111)"
		        zIndex="2"
				/>
			<Box
				top="0" 
				position="absolute" 
				w="100%" 
				borderRadius="30px" sx={{aspectRatio: '1'}}
				transform = { isAnimateDislike ? 'scale(0.7) rotate(-10deg)' : isAnimateLike ? 'scale(0.7) rotate(10deg)' : 'scale(0.99) rotate(-0deg)'}
		        transition="transform 0.3s ease-out"
		        willChange="transform"
		        bg="#ffffffad"
		        zIndex="1"
		        boxShadow="12px 11px 19px #f2e3dfad"
				/>

			<Flex 
				pl="24px"
				position="absolute" 
				bottom="0" 
				zIndex="999" 
				w="100%" 
				transform = { isAnimateDislike ? 'scale(0.76) rotate(-10deg)' : isAnimateLike ? 'scale(0.76) rotate(10deg)' : 'scale(0.99) rotate(-5deg)'}
		        transition="transform 0.5s ease-out"
		        willChange="transform"
				justifyContent="space-around">
				<Box
					className="unlike"
					onClick={() => { 
            setDisLike(groups[active]?.id);
            handleDislike(active + 1);
          }}>
					<IoCloseOutline color="#535353" fontSize="32px" />
				</Box>

				<Box
					className="like"
					onClick={
              () => {
                setLike(groups[active]?.id);
                //handleLike(active + 1);
              }
            }
					> <FaHeart color="rgb(255, 65, 51)" fontSize="32px" />
				</Box>
	    </Flex>

		</Box>
		
    </Box>
  }

 	<BalanceModal
    handle={handleBalance}
    isOpen={isOpenBalance}
    onClose={onCloseBalance}
  />

  <FiltersModal
    interests={listInterests}
    toggleInterest={toggleInterest}
    isOpen={isOpenFilters}
    onClose={onCloseFilters}
    globalSearch={globalSearch}
    setGlobalSearch={setGlobalSearch}
  />

  </Box>
  );
};

export default MatchGroup;